// Sprout & Paws — bottom-anchored sticky for the product info column.
// Dawn pins .product__column-sticky at top: 3rem; with the Bundle & Save
// picker the buy box is taller than the viewport, so its bottom (bundle cards,
// ATC) stays hidden while the gallery scrolls. When the column is taller than
// the viewport we set a negative sticky top (100vh - height) so the column
// scrolls fully into view first, pins bottom-anchored, then the gallery keeps
// scrolling. Height changes (accordions, variant swaps) re-trigger via
// ResizeObserver.
(function () {
  function init() {
    var el = document.querySelector('.product__info-container.product__column-sticky');
    if (!el) return;
    var GAP = 24; // px breathing room below the pinned column

    function update() {
      if (window.innerWidth < 750) {
        el.style.removeProperty('--sp-sticky-top');
        return;
      }
      var h = el.offsetHeight;
      var vh = window.innerHeight;
      if (h + GAP + 30 > vh) {
        el.style.setProperty('--sp-sticky-top', (vh - h - GAP) + 'px');
      } else {
        el.style.removeProperty('--sp-sticky-top');
      }
    }

    update();
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(el);
    setTimeout(update, 1500); // late layout shifts (fonts, deferred widgets)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
